import { Link } from 'react-router-dom'
import { Mail, Phone } from 'lucide-react'
import { Logo } from '@/components/ui/Logo'
import { useSettings } from '@/context/SettingsContext'
import { ROUTES } from '@/constants'

export function Footer() {
  const { brandName, supportPhone, contactEmail } = useSettings()

  return (
    <footer className="border-t border-charcoal-100 bg-sand-100 pt-10 sm:pt-12">
      <div className="mx-auto max-w-7xl px-4 pb-8 sm:px-6 lg:px-8">
        {/*
          Phones: brand on top, Shop and Help side by side, contact below.
          Tablets: brand across the top, then the three link columns.
          minmax(0,1fr) rather than 1fr: the logo PNG is 4500px wide and its
          intrinsic width would otherwise stretch the first column and push
          the page wider than the screen.
        */}
        <div className="grid grid-cols-2 gap-x-6 gap-y-8 md:grid-cols-[repeat(3,minmax(0,1fr))] md:gap-8 lg:grid-cols-[repeat(4,minmax(0,1fr))] lg:gap-10">
          <div className="col-span-2 md:col-span-3 lg:col-span-1">
            <Logo variant="full" size={64} className="-ml-2 max-w-[10rem]" />
            <p className="mt-3 text-sm text-charcoal-600">
              Premium baby essentials, trusted by parents across Bangladesh.
            </p>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-bold uppercase tracking-wide text-charcoal">Shop</h4>
            <ul className="space-y-2 text-sm text-charcoal-600">
              <li><Link className="hover:text-coral" to={`${ROUTES.shop}?category=clothing`}>Clothing</Link></li>
              <li><Link className="hover:text-coral" to={`${ROUTES.shop}?category=breast-pumps`}>Breast Pumps & Accessories</Link></li>
              <li><Link className="hover:text-coral" to={`${ROUTES.shop}?category=nursing`}>Nursing Accessories</Link></li>
              <li><Link className="hover:text-coral" to={`${ROUTES.shop}?category=bottles`}>Baby Bottles & Nipples</Link></li>
              <li><Link className="hover:text-coral" to={`${ROUTES.shop}?category=toys`}>Toys</Link></li>
              <li><Link className="hover:text-coral" to={`${ROUTES.shop}?category=others`}>Others</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-bold uppercase tracking-wide text-charcoal">Help</h4>
            <ul className="space-y-2 text-sm text-charcoal-600">
              <li><Link className="hover:text-coral" to={ROUTES.about}>About Us</Link></li>
              <li><Link className="hover:text-coral" to={ROUTES.contact}>Contact</Link></li>
              <li><Link className="hover:text-coral" to={ROUTES.trackOrder}>Track Your Order</Link></li>
              <li><Link className="hover:text-coral" to={ROUTES.returnPolicy}>Return & Refund Policy</Link></li>
              <li><span>FAQ</span></li>
            </ul>
          </div>

          <div className="col-span-2 md:col-span-1">
            <h4 className="mb-3 text-sm font-bold uppercase tracking-wide text-charcoal">Contact</h4>
            <ul className="space-y-2 text-sm text-charcoal-600">
              <li className="flex items-start gap-2">
                <Phone size={16} className="mt-0.5 text-coral" />
                <a href={`tel:+${supportPhone}`} className="hover:text-coral">+{supportPhone}</a>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={16} className="mt-0.5 text-coral" />
                <a href={`mailto:${contactEmail}`} className="break-all hover:text-coral">{contactEmail}</a>
              </li>
              <li>Customer care available 24/7</li>
            </ul>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-2 border-t border-charcoal-100 pt-6 text-center text-xs text-charcoal-600 sm:mt-10 sm:flex-row sm:text-left">
          <span>© {new Date().getFullYear()} {brandName}. All rights reserved.</span>
          <span>Made with ♥ in Bangladesh</span>
        </div>
      </div>
    </footer>
  )
}
